import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { QueryParams } from 'src/app/core/models/query-params.model';
import { AuthService } from 'src/app/shared/services/auth.service';

import { SgrResponse } from 'src/app/core/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private url: string = environment.API;
  private behaviorSubject: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {}

  getBehaviorSubject(): BehaviorSubject<boolean | null> {
    return this.behaviorSubject;
  }

  sendGetNotification(value: boolean): void {
    this.behaviorSubject.next(value);
  }

  //? CHAMADAS AO BACKEND

  //cadastro de notificacoes
  createNotificacao(params: { body: string; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    let endpoint = this.url + '/notificacao';
    let options = this.authService.setHttpOptions(params ?? {});
    return this.httpClient.post<SgrResponse>(endpoint, params.body, options);
  }

  //busca notificacoes
  getNotificacao(params?: { queryParams?: QueryParams; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    let endpoint = this.url + '/notificacao';
    let options = this.authService.setHttpOptions(params ?? {});
    return this.httpClient.get<SgrResponse>(endpoint, options);
  }

  //envia notificacoes
  updateNotificacao(params: { body: string; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    let endpoint = this.url + '/notificacao';
    let options = this.authService.setHttpOptions(params ?? {});
    return this.httpClient.put<SgrResponse>(endpoint, params.body, options);
  }

  //deleta notificacoes
  deleteNotificacao(params?: { queryParams?: QueryParams; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    let endpoint = this.url + '/notificacao';
    let options = this.authService.setHttpOptions(params ?? {});
    return this.httpClient.delete<SgrResponse>(endpoint, options);
  }
}
